import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'
import DashboardProtectedRoute from './NavigationRoutesUtility/dashboardRoutes';
import PazientiProtectedRoute from './NavigationRoutesUtility/pazientiRoutes';
import RuoliProtectedRoute from './NavigationRoutesUtility/ruoliRoutes';
import ChangelogProtectedRoute from './NavigationRoutesUtility/changelogRoutes';
import CommonProtectedRoute from './NavigationRoutesUtility/commonRoutes';
import MagazzinoProtectedRoute from './NavigationRoutesUtility/magazzinoRoutes';
import FinanceProtectedRoute from './NavigationRoutesUtility/financeRoutes';

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]


// Definizione delle sezioni di menu
const menuRoutesEnabledSections = {
    dashboard: DashboardProtectedRoute.getNavTree(),
    dashboardSuperadmin: DashboardProtectedRoute.getNavTreeSuperadmin(),
    dashboardContabile: DashboardProtectedRoute.getNavTreeContabile(),

    pazienti: PazientiProtectedRoute.getNavTreeSuperadmin(),
    pazientiSuperadmin: PazientiProtectedRoute.getNavTreeSuperadmin(),
    ruoli: RuoliProtectedRoute.getNavTree(),
    changelog: ChangelogProtectedRoute.getNavTree(),
    common: CommonProtectedRoute.getNavTree(),
    magazzino: MagazzinoProtectedRoute.getNavTree(),
    finance: FinanceProtectedRoute.getNavTree(),
   
};


// Funzione per generare dinamicamente il menu
const getNavigationConfig = (centro, role) => {
    const allowedSections = rolesRoutesPermissions[centro][role] || [];
    return allowedSections.flatMap(section => menuRoutesEnabledSections[section] || []);
};


export const rolesRoutesPermissions = {
    centro_medico: {
        operatore: ['dashboard', 'pazienti', 'common'],
        operatore_contabile: ['dashboard', 'pazienti', 'common'],
        superadmin: ['dashboardSuperadmin', 'pazientiSuperadmin', 'changelog', 'common'],
    },
    centro_contabile: {
        contabile: ['finance', 'magazzino', 'common'],
        operatore_contabile: ['finance', 'magazzino', 'common'],
        superadmin: ['finance', 'magazzino', 'changelog', 'common'],
    },
    centro_amministrativo: {
        superadmin: ['ruoli', 'changelog', 'common'],
    }
};

const roleRoutesUtility = (centro, role) => getNavigationConfig(centro, role) || [];
export { roleRoutesUtility };
